var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8485 7V4.66667C11.8485 4.48985 11.7751 4.32029 11.6444 4.19526C11.5137 4.07024 11.3364 4 11.1515 4H2.78791C2.60306 4 2.42579 4.07024 2.29508 4.19526C2.16438 4.32029 2.09094 4.48985 2.09094 4.66667V11.3333C2.09094 11.5101 2.16438 11.6797 2.29508 11.8047C2.42579 11.9297 2.60306 12 2.78791 12H11.1515C11.3364 12 11.5137 11.9297 11.6444 11.8047C11.7751 11.6797 11.8485 11.5101 11.8485 11.3333V9L14.6364 11.6667V4.33333L11.8485 7ZM5.57579 10V6L8.71215 8L5.57579 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTutorials);
export default __webpack_public_path__ + "static/media/video_tutorials.ea162661847c31ae609538ac07d1bd1c.svg";
export { ForwardRef as ReactComponent };